export default {
    fullBody: {
        key: 'fullBody',
        displayName: '全身',
        fundamental: [
          {
            displayName: "高矮",
            pos: ['height_high'],
            neg: ['height_short']
          },
          {
            displayName: "胖瘦",
            pos: ['fatThin_fat'],
            neg: ['fatThin_thin']
          }]
    },
    head: {
        key: 'head',
        displayName: '头部',
        fundamental: [{
            displayName: "大小",
            pos: ['head_size_large'],
            neg: ['head_size_small']
          }]
    }
    ,
    neck: {
        key: 'neck',
        displayName: '脖子',
        fundamental: [{
            displayName: "长短",
            pos: ['neck_length_long'],
            neg: ['neck_length_short']
          },
          {
            displayName: "粗细",
            pos: ['neck_thickness_thick'],
            neg: ['neck_thickness_thin']
          }]
    },
    shoulder: {
        key: 'shoulder',
        displayName: '肩部',
        fundamental: [{
            displayName: "宽度",
            pos: ['shoulder_width_wide'],
            neg: ['shoulder_width_narrow']
          },
          {
            displayName: "粗细",
            pos: ['shoulder_thickness_thick'],
            neg: ['shoulder_thickness_thin']
          }]
    },
    chest: {
        key: 'chest',
        displayName: '胸部',
        fundamental: [{
            displayName: "宽度",
            pos: ['chest_width_wide'],
            neg: ['chest_width_narrow']
          },
          {
            displayName: "大小",
            pos: ['chest_size_large'],
            neg: ['chest_size_small']
          }]
    },
    arms: {
        key: 'arms',
        displayName: '手臂',
        fundamental: [{
            displayName: "双手长短",
            pos: ['arms_length_long'],
            neg: ['arms_length_short']
          },
          {
            displayName: "双手粗细",
            pos: ['arms_thickness_thick'],
            neg: ['arms_thickness_thin']
          },
          {
            displayName: "手掌大小",
            pos: ['hands_size_large'],
            neg: ['hands_size_small']
        }],
    },
    upperarm: {
        key: 'upperarm',
        displayName: '大臂',
        fundamental: [{
            displayName: "长度",
            pos: ['upperarm_length_long'],
            neg: ['upperarm_length_short']
          },
          {
            displayName: "粗细",
            pos: ['upperarm_thickness_thick'],
            neg: ['upperarm_thickness_thin']
          }]
    },
    lowerarm: {
        key: 'lowerarm',
        displayName: '小臂',
        fundamental: [{
            displayName: "长度",
            pos: ['lowerarm_length_long'],
            neg: ['lowerarm_length_short']
          },
          {
            displayName: "粗细",
            pos: ['lowerarm_thickness_thick'],
            neg: ['lowerarm_thickness_thin']
        }],
    },
    waist: {
        key: 'waist',
        displayName: '腰部',
        fundamental: [{
            displayName: "长短",
            pos: ['waist_length_long'],
            neg: ['waist_length_short']
          },
          {
            displayName: "粗细",
            pos: ['waist_thickness_thick'],
            neg: ['waist_thickness_thin']
        }],
    },
    abdominal: {
        key: 'abdominal',
        displayName: '腹部',
        fundamental: [{
            displayName: "大小",
            pos: ['abdominal_size_large'],
            neg: ['abdominal_size_small']
        }]
    },
    hips: {
        key: 'hips',
        displayName: '臀部',
        fundamental: [{
            displayName: "大小",
            pos: ['hips_size_large'],
            neg: ['hips_size_small']
          }]
    },
    leg: {
        key: 'leg',
        displayName: '双腿',
        fundamental: [{
            displayName: "双腿长度",
            pos: ['legs_length_long'],
            neg: ['legs_length_short']
          },
          {
            displayName: "双腿粗细",
            pos: ['legs_thickness_thick'],
            neg: ['legs_thickness_thin']
          },
          {
            displayName: "脚掌大小",
            pos: ['foot_size_large'],
            neg: ['foot_size_small']
        }]
    },
    upperleg: {
        key: 'upperleg',
        displayName: '大腿',
        fundamental: [{
            displayName: "长度",
            pos: ['upperleg_length_long'],
            neg: ['upperleg_length_short']
          },
          {
            displayName: "粗细",
            pos: ['upperleg_thickness_thick'],
            neg: ['upperleg_thickness_thin']
          }],
    },
    lowerleg: {
        key: 'lowerleg',
        displayName: '小腿',
        fundamental: [{
            displayName: "长度",
            pos: ['lowerleg_length_long'],
            neg: ['lowerleg_length_short']
          },
          {
            displayName: "粗细",
            pos: ['lowerleg_thickness_thick'],
            neg: ['lowerleg_thickness_thin']
        }]
    }
};